<script>
export default {
  props: {
    show: Boolean,
    numeroDocumento: String
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<template>
  <Transition name="modal">
    <div v-if="show" class="modal-mask user-modal__backdrop">
      <div class="modal-wrapper">
        <div class="modal-container user-modal__panel user-modal__body">
          <div class="modal-close">
            <slot name="close-button">
              <button class="modal-default-button user-modal__close" @click="$emit('close')">
                <span class="material-icons-sharp" aria-hidden="true">cancel</span>
              </button>
            </slot>
          </div>
          <div class="modal-header">
            <h3 class="user-modal__title">Ejemplo:</h3>
          </div>

          <div class="modal-body modal-header user-modal__body">
            <p>
              El Nº de identificación que registraste en Arcadi es
              {{ numeroDocumento }}.
            </p>
            <p>
              Por lo tanto, si deseas abonar a tu saldo en Arcadi, por ejemplo,
              $50.000 COP, debes transferirnos $50.00{{
                numeroDocumento.slice(-1)
              }}
              COP o $49.99{{ numeroDocumento.slice(-1) }} COP.
            </p>
            <p>De esta forma identificaremos fácilmente tu pago.</p>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
}

.modal-wrapper { display: block; width: 100%; }
.modal-container { position: relative; display: flex; flex-direction: column; margin: auto; }
.modal-close { display: contents; }
.modal-body p + p { margin-top: var(--user-modal-gap); }
.modal-body { overflow-wrap: anywhere; }
.modal-enter-from, .modal-leave-to { opacity: 0; }
.modal-enter-from .modal-container, .modal-leave-to .modal-container { transform: scale(1.1); }
</style>
